import * as React from 'react';

import classnames from 'classnames';

import {RadioGroupContext} from './radio-group';

import styles from '../checkbox/checkbox-button.module.css';

type Props = {
    value: string;
    icon: React.ReactNode;
    children?: React.ReactNode;
};

export class RadioIconButton extends React.Component<Props> {
    render() {
        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    return (
                        <div
                            onClick={() => onChange(this.props.value)}
                            className={classnames(styles['input-button-icon'], {
                                [styles.checked]: checked,
                            })}
                        >
                            <div className={styles['icon-container']}>{this.props.icon}</div>
                            <label htmlFor={radioId}>{this.props.children}</label>
                        </div>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }
}
